"use client";

import { useState, useEffect } from 'react';
import Link from 'next/link';
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from '@/components/ui/button';
import { Gift } from 'lucide-react';
import { onAuthStateChanged, User } from 'firebase/auth';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { auth, db } from '@/lib/firebase';
import type { User as AppUser } from '@/lib/types';


export default function FreeSpinPopup() {
    const [showPopup, setShowPopup] = useState(false);
    const [user, setUser] = useState<User | null>(null);
    const [appUser, setAppUser] = useState<AppUser | null>(null);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
            setUser(currentUser);
            if(currentUser){
                const userDoc = await getDoc(doc(db, 'users', currentUser.uid));
                if(userDoc.exists()){
                    setAppUser(userDoc.data() as AppUser);
                }
            } else {
                setAppUser(null);
            }
        });
        return () => unsubscribe();
    }, []);

    useEffect(() => {
        if (!user || !appUser) {
            setShowPopup(false);
            return;
        }

        const today = new Date().toISOString().split('T')[0];
        
        if (appUser.lastFreeSpin !== today) {
            const timer = setTimeout(() => {
                setShowPopup(true);
            }, 3000); 
            return () => clearTimeout(timer);
        }
    }, [user, appUser]);

    if (!showPopup) {
        return null;
    }

    return (
        <AlertDialog open={showPopup} onOpenChange={setShowPopup}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <div className="mx-auto w-fit rounded-full bg-primary/20 p-4 mb-4">
                        <Gift className="h-12 w-12 text-primary" />
                    </div>
                    <AlertDialogTitle className="text-center text-2xl font-headline">Você tem um Giro Grátis!</AlertDialogTitle>
                    <AlertDialogDescription className="text-center">
                        Sua chance diária de ganhar prêmios incríveis na nossa Roleta de Prêmios está esperando por você. Não perca!
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter className="sm:justify-center flex-col sm:flex-col sm:space-x-0">
                    <Button asChild className="w-full" size="lg">
                        <Link href="/roletadepremios">
                            Girar Agora!
                        </Link>
                    </Button>
                    <AlertDialogCancel asChild>
                       <Button variant="ghost">Fechar</Button>
                    </AlertDialogCancel>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    )
}
